// Polyfill
//https://github.com/LinusU/react-native-get-random-values
import { EnvironmentName, setupEnvironment } from "@citychallenge/core";
import { UAParser } from "ua-parser-js";

import { WEB_CONFIG } from "./core/web-config";
import { LazySentry as Sentry } from "./lazy-sentry";

declare global {
  const APP_VERSION: string;
}
// Set offline progress events to once per 100ms

const env = new UAParser(navigator.userAgent);

function getEnvironmentName(): EnvironmentName {
  return WEB_CONFIG.ENVIRONMENT_NAME as EnvironmentName;
}

const browserName = env.getBrowser().name;
const os = env.getOS().name;
const osSuffix = os ? ` / ${os}` : "";
const version = env.getBrowser().version || "n/a";
const deviceType = env.getDevice().type || "default";

setupEnvironment(getEnvironmentName(), {
  version: APP_VERSION,
  buildNumber: "web",
  deviceId: browserName ? `${browserName}${osSuffix}` : "n/a",
  deviceType: deviceType as any,
  systemVersion: version,
  OS: "web",
  // Cast: the lazy shim is structurally compatible with the methods
  // Environment.Sentry expects (Pick<typeof @sentry/core, ...>), but its
  // function signatures are typed off @sentry/react which TS treats as
  // incompatible due to overload widening.
  Sentry: Sentry as any,
  Dimensions: {
    get: (type) => {
      if (type === "screen")
        return {
          width: window.screen.width,
          height: window.screen.height,
        };

      return {
        width: window.innerWidth,
        height: innerWidth,
      };
    },
  },
});
